// TODO: Fix eslint errors.
/* eslint-disable */
import React, {
  useState, useRef, useEffect, useContext,
} from 'react';
import { injectIntl } from 'react-intl';
import Icon from '@UI/Icon';
import axios from 'axios';
import { useRouteMatch } from 'react-router-dom';
import dispatchEvent from "dispatchEvent";
import jobUrlBuilder from 'jobUrlBuilder';
import { markAsFavorite, deleteFromFavorite, getQuantity } from 'anonFavJobs';

function SaveJob({ jobData, baseUrl, size, saveJobModalCb, additionalClass = '', favoriteIconProps = {}, favoriteJobs = []}) {
  const [favorite, setFavorite] = useState(favoriteJobs && favoriteJobs.hasOwnProperty(jobData.BlueXJobData.JobId));

  const favoriteWrapper = useRef();
  const route = useRouteMatch();
  const jobId = jobData.BlueXJobData.JobId;
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    setFavorite(favoriteJobs && favoriteJobs.hasOwnProperty(jobData.BlueXJobData.JobId));
  }, [favoriteJobs]);

  const favoriteJob = (event) => {
    // Prevent multiple XHR requests.
    if (event.target.classList.contains('processing')) {
      return;
    }
    event.target.classList.add('processing');

    event.preventDefault();
    event.persist();
    if (favorite) {
      axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
        callback: '@Callbacks/deleteFavoriteJob',
        currentRoute: route,
        data: {
          job: jobData,
        },
      }).then((response) => {
        // Users are not logged and we have to store their choice somewhere else.
        if (response.data.status === 403) {
          deleteFromFavorite(jobId);
        }
        favoriteWrapper.current.classList.remove('icon__toggler--active');
        setFavorite(false);
        // Dispatch event, a listener will be added in the shared scripts
        // for the OpCos that need to act on this (icon in the header).
        dispatchEvent('deleteFavoriteJob');
        event.target.classList.remove('processing');
      });
    } else {
      axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
        callback: '@Callbacks/saveFavoriteJob',
        currentRoute: route,
        data: {
          job: jobData,
          jobUrl: jobUrlBuilder(jobData, baseUrl),
        },
      }).then((response) => {
        if (response.data.status === 403) {
          const numOfFavJobs = getQuantity();

          if (numOfFavJobs < process.env.REACT_APP_FAVORITE_JOBS_LIMIT) {
            markAsFavorite(jobId, response.data.jobData);
          } else {
            // Render SaveJobModal modal.
            saveJobModalCb(true);
            return;
          }
        }

        favoriteWrapper.current.classList.add('icon__toggler--active');
        setFavorite(true);

        // Dispatch event, a listener will be added in the shared scripts
        // for the OpCos that need to act on this (icon in the header).
        dispatchEvent('saveFavoriteJob');
        event.target.classList.remove('processing');
      });
    }
  };

  const onPressFavIcon = (e) => {
    if (e.key === 'Enter') {
      favoriteJob(e);
    }
  };

  return (
    <button key={jobId} className={`icon__toggler icon--l ${favorite ? 'icon__toggler--active' : ''} ${additionalClass}`} onClick={favoriteJob} onKeyDown={onPressFavIcon} ref={favoriteWrapper} aria-pressed={favorite ? 'true' : 'false'} {...favoriteIconProps} id={`fav-${jobId}`}>
      <span className={`icon ${size ? `icon--${size}` : ''} icon--inline`}>
        <Icon type="heart-30" />
      </span>
      <span className={`icon ${size ? `icon--${size}` : ''} icon--inline`}>
        <Icon type="heart-filled-30" />
      </span>
    </button>
  );
}

export default injectIntl(SaveJob);
